<template>
  <div
    id="admin-performance-view"
    class="pa-4"
  >
    <v-card
      rounded
    >
      <v-card-title class="px-8">
        <v-row align="center">
          <v-col>
            <div class="text-h6">
              {{ $t("card_title.performance_analysis") }}
            </div>
          </v-col>
          <v-col cols="auto">
            <v-btn
              color="primary"
              class="text-none"
              :loading="submitting"
              @click="save"
            >
              {{ $t('button.save') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider />
      <div style="height: 1px">
        <v-progress-linear
          v-if="submitting"
          indeterminate
          color="primary"
          :height="1"
        />
      </div>
      <v-card-text class="px-8">
        <performance-variable-selection
          default-view="SUMMARY"
          @input="input"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { OrganisationApiService } from '@/data/services/OrganisationApiService'
import PerformanceVariableSelection from '@/components/performance/PerformanceVariableSelection.vue'

export default {
  name: 'AdminPerformanceView',
  components: { PerformanceVariableSelection },
  data: () => ({
    submitting: false,
    payload: {}
  }),
  computed: {
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    }
  },
  created() {
  },
  methods: {
    async save() {
      this.submitting = true

      try {
        await OrganisationApiService.saveVariables(this.user.organisation_id, this.payload)

        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.variables_save.success'),
          color: 'success'
        })
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.variables_save.error'),
          color: 'error'
        })
      } finally {
        this.submitting = false
      }
    },
    input(data) {
      this.payload = data
    }
  }

}
</script>

<style scoped>

</style>
